module.exports = __webpack_public_path__ + "img/bar-chart-dark-02.645a0691.jpg";